import { i18n } from '@/plugins/i18n'

export const requestType = {
    UPDATE_RELATED_MERCHANT_LIST: 1,
}

export const requestTypeStr = {
    UPDATE_RELATED_MERCHANT_LIST: i18n.t('dedicated_request_type.update_related_merchant_list'),

    get(type) {
        let type_str = null;

        Object.keys(requestType).forEach(item => {
            if(requestType[item] === type) {
                type_str = requestTypeStr[item];
            }
        });

        return type_str;
    }
}